@import 'styles/mixins';
@import 'styles/variables';

.positionContainer {
  pointer-events: none;
  position: absolute;
  width: 100%;
}

.contentContainer {
  @include body-md-text;

  color: $gray-40;
  margin-top: 0px;
  padding-bottom: var(--body-padding-bottom, 4px);
  padding-left: 2px;
  padding-top: var(--body-padding-top, 4px);
  text-align: var(--body-text-align, inherit);

  // This does not fix the problem (EDI-781) in Safari but it does in Firefox
  //   and not hiding the EmptyPrompt on blur eliminated the need for knowing where to click (EDI-1566 / EDI-1627)
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                supported by Chrome, Edge, Opera and Firefox */
  kbd {
    background: $gray-5;
    border-radius: 4px;
    padding: 2px 9px;
    font-family: inherit;
  }
}

.afterLabel {
  margin-top: 1px;
}

.slashContainer {
  background: $gray-5;
  border-radius: 4px;
  padding: 2px 9px;
}
